var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState, useCallback } from 'react';
import { useAsyncData } from '../../social/providers/DataFetchingProvider';
import { PARTNER_METADATA } from '../constants';
export function useNoomUserMetadata(userId) {
    const [metadata, setMetadata] = useState({});
    const { getUserMetadata, updateUserMetadata } = useAsyncData();
    const getMetadata = useCallback((userId, callback) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield (getUserMetadata === null || getUserMetadata === void 0 ? void 0 : getUserMetadata(userId));
        callback === null || callback === void 0 ? void 0 : callback((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : {});
    }), [getUserMetadata]);
    const updateMetadata = useCallback((userId, newMetadata, callback) => __awaiter(this, void 0, void 0, function* () {
        var _b, _c;
        newMetadata[PARTNER_METADATA] = (_b = parseInt(newMetadata[PARTNER_METADATA])) !== null && _b !== void 0 ? _b : undefined;
        const response = yield (updateUserMetadata === null || updateUserMetadata === void 0 ? void 0 : updateUserMetadata(userId, Object.assign(Object.assign({}, metadata), newMetadata)));
        callback === null || callback === void 0 ? void 0 : callback((_c = response === null || response === void 0 ? void 0 : response.data) !== null && _c !== void 0 ? _c : {});
    }), [updateUserMetadata, metadata]);
    useEffect(() => {
        getMetadata(userId, setMetadata);
    }, [userId]);
    return {
        metadata,
        updateMetadata,
    };
}
//# sourceMappingURL=useNoomUserMetadata.js.map